import React, { useState, useEffect } from "react"
import NextImg from "@/common/components/NextImg"
import styled from "styled-components"
import BBlock from "./BBlock"
import Panel from "./Panel"
import CircleBG from "@/containers/MoneyFortune/View/completeQA/CircleBG"

export default function ResultCard({
  name,
  roleID,
  peopleName,
  AKA,
  chance,
  saying,
  summary,
  analysis,
  investment,
  befit,
  img,
  type,
  resultImg,
  reset,
  API,
  GetAndShare,
  phone,
  setPhone,
  setAnswerInfoHandler,
  saveAnswerInfoToAPI,
  getTraitId,
  setResult
}) {
  const [showPanel, setShowPanel] = useState("close")
  const [panelContent, setPanelContent] = useState()
  useEffect(() => {
    setResult(name)
  }, [])

  return (
    <BG>
      <Wrapper>
        <CircleWrapper>
          <CircleBG />
        </CircleWrapper>
        <ResultImgWrapper>
          <NextImg src={img} />
        </ResultImgWrapper>
        <ResultImgMobileWrapper>
          <NextImg src={resultImg} />
        </ResultImgMobileWrapper>
        <BBlockWrapper>
          <BBlock
            img={img}
            setShowPanel={setShowPanel}
            setPanelContent={setPanelContent}
            roleID={roleID}
            type={type}
            reset={reset}
            resultImg={resultImg}
            API={GetAndShare.API}
            GetAndShare={GetAndShare}
            phone={phone}
            setPhone={setPhone}
            setAnswerInfoHandler={setAnswerInfoHandler}
            saveAnswerInfoToAPI={saveAnswerInfoToAPI}
            showPanel={showPanel}
            getTraitId={getTraitId}
          />
        </BBlockWrapper>
      </Wrapper>
      <Panel
        showPanel={showPanel}
        setShowPanel={setShowPanel}
        content={panelContent}
      />
    </BG>
  )
}
const BG = styled.div`
  background-color: #040927;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  @media (max-width: 1280px) {
    justify-content: start;
    align-items: start;
    height: auto;
  }
`

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  max-width: 1300px;
  /* padding: 40px 40px 40px 40px; */
  margin: 0 auto;
  gap: 20px;

  @media (max-width: 1280px) {
    flex-direction: column;
    max-height: 100%;
    height: auto;
    max-width: 800px;
    justify-content: center;
    max-width: 450px;
    padding: 0px;
    min-height: var(--vh);
    gap: 0px;
  }
  @media (max-width: 768px) {
    /* height: 100vh; */
  }
  @keyframes fade {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeup {
    0% {
      transform: translate(0, 300px);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadedown {
    0% {
      transform: translate(0, -300px);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes fadeleft {
    0% {
      transform: translate(-300px, 0);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes faderight {
    0% {
      transform: translate(300px, 0);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes zoomin {
    0% {
      transform: translate(-50%, -50%) scale(0.1);
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`

const BBlockWrapper = styled.div`
  position: absolute;
  width: clamp(200px, 46%, 800px);
  bottom: 9px;
  left: 56%;
  transform: translate(-50%, -50%);
  display: flex;
  @media (max-width: 1280px) {
    position: relative;
    padding: 20px;
    width: 100%;
    bottom: 0;
    left: 0%;
    transform: translate(0%, 0%);
  }
  .RoleWrapper {
    opacity: 0;
    animation: zoomin 0.6s forwards ease-out 1s;
    will-change: transform;
  }
  .BottomWrapper {
    opacity: 0;
    animation: fade 1s forwards 2s ease-in-out;
    @media (max-width: 1200px) {
      opacity: 0;
      animation: fade 1s forwards ease-in-out;
    }
  }
`

const ResultImgWrapper = styled.div`
  width: 100%;
  animation: fade 2s forwards ease-in-out;
  @media (max-width: 1280px) {
    display: none;
  }
`
const ResultImgMobileWrapper = styled.div`
  display: none;
  @media (max-width: 1280px) {
    animation: fade 2s forwards ease-in-out;
    display: block;
  }
`
const CircleWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0px;
  width: 100%;

  .c1 {
    animation: circle 1s forwards ease 2;
  }
  .c2 {
    animation: circle 1s forwards ease 0.2s 1;
  }
  .c3 {
    animation: circle 1s forwards ease 0.5s 1;
  }
`
